import { BuildingMenuType } from '@/enums';
import { PATHS } from '@/router/paths';
import { MENU_ICONS } from './menu-icons';

export const DEFAULT_MENUS = [
    {
        id: 'home',
        type: BuildingMenuType.HOME,
        route: PATHS.HOME.INDEX,
        label: '홈',
        icon: MENU_ICONS.HOME,
        ariaLabel: '홈',
        dataDesc: '메인 페이지로 돌아갑니다',
    },
    {
        id: 'floor-guide',
        type: BuildingMenuType.FLOOR,
        route: PATHS.FLOOR_GUIDE.INDEX,
        label: '층별안내',
        icon: MENU_ICONS.FLOOR,
        ariaLabel: '층별 안내 페이지로 이동',
        dataDesc: '각 층의 시설과 매장을 안내합니다',
    },
    {
        id: 'search',
        type: BuildingMenuType.SEARCH,
        label: '매장검색',
        icon: MENU_ICONS.SEARCH,
        route: PATHS.SHOP.INDEX,
        ariaLabel: '매장 검색 페이지로 이동',
        dataDesc: '원하는 매장을 검색할 수 있습니다',
    },
    {
        id: 'fnb',
        type: BuildingMenuType.FNB,
        label: 'F&B',
        icon: MENU_ICONS.FNB,
        route: PATHS.FNB.INDEX,
        ariaLabel: 'F&B 페이지로 이동',
        dataDesc: '음식점과 카페 정보를 확인할 수 있습니다',
    },
    {
        id: 'events',
        type: BuildingMenuType.EVENT,
        label: '행사안내',
        icon: MENU_ICONS.EVENT,
        route: PATHS.EVENTS.INDEX,
        ariaLabel: '행사안내 페이지로 이동',
        dataDesc: '진행중인 행사와 이벤트를 확인할 수 있습니다',
    },
    {
        id: 'parking',
        type: BuildingMenuType.PARKING,
        label: '주차안내',
        icon: MENU_ICONS.PARKING,
        route: PATHS.PARKING.INDEX,
        ariaLabel: '주차안내 페이지로 이동',
        dataDesc: '주차장 위치와 요금을 안내합니다',
    },
    {
        id: 'facility',
        type: BuildingMenuType.FACILITIES,
        label: '편의시설',
        icon: MENU_ICONS.FACILITIES,
        route: PATHS.FACILITY.INDEX,
        ariaLabel: '편의시설 페이지로 이동',
        dataDesc: '화장실, 수유실 등 편의시설을 안내합니다',
    },
    {
        id: 'faq',
        type: BuildingMenuType.FAQ,
        label: '자주 묻는 질문',
        icon: MENU_ICONS.FAQ,
        route: PATHS.FAQ.INDEX,
        ariaLabel: '자주 묻는 질문 페이지로 이동',
        dataDesc: '고객님들이 자주 묻는 질문과 답변을 확인할 수 있습니다',
    },
];

export const JAMSIL_MAP_IDS = ['e2048cd2-68f3-44fd-8310-0c30a43f6092','e6991273-c6ee-42a9-afe3-d31ded262703'];
